import { render, staticRenderFns } from "./ResourceTreeTender.vue?vue&type=template&id=4b74a50e&scoped=true"
import script from "./ResourceTreeTender.vue?vue&type=script&lang=js"
export * from "./ResourceTreeTender.vue?vue&type=script&lang=js"
import style0 from "./ResourceTreeTender.vue?vue&type=style&index=0&id=4b74a50e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74a50e",
  null
  
)

export default component.exports